export const columnWidth = {
    'homeState': 150,
    'insuredName': 250,
    'policyNumber': 250,
    'invoiceNumber': 180,
    'needDiligentSearch': 220,
    'diligentSearchNotes': 220,
    'diligentSearchCompleted': 250,
    'dateCompleted': 220,
    'suspended': 150,
    'transactionType': 200,
    'carrier': 300,
    'naic': 120,
    'invDate': 180,
    'policyEffDate': 180,
    'policyExpDate': 180,
    'grossPremium': 180,
    'client': 250,
    'actions': 90,
}

export const licenseMatrixColumnList = [
    {
        id: 0,
        field: 'licensee',
        xlsHeader: 'Licensee',
        inputType: 'string'
    },
    {
        id: 0,
        field: 'licenseState',
        xlsHeader: 'License State',
        inputType: 'string'
    },
    {
        id: 0,
        field: 'licenseNumber',
        xlsHeader: 'License Number',
        inputType: 'string'
    },
    {
        id: 0,
        field: 'customerName',
        xlsHeader: 'Clients Name',
        inputType: 'string'
    },
    {
        id: 0,
        field: 'mainLicensee',
        xlsHeader: 'Main Licensee',
        inputType: 'string'
    },
    {
        id: 0,
        field: 'entity',
        xlsHeader: 'Entity',
        inputType: 'string'
    },
    {
        id: 0,
        field: 'npn',
        xlsHeader: 'NPN',
        inputType: 'string'
    },
    {
        id: 0,
        field: 'fein',
        xlsHeader: 'FEIN',
        inputType: 'string'
    },
    {
        id: 0,
        field: 'cancellationDate',
        xlsHeader: 'Cancellation Date',
        inputType: 'date'
    },
]